import React from 'react';

const ItemwiseSalesSummaryReportHeader = () => (
    <h1>Itemwise Sales Summary Report</h1>
);

export default ItemwiseSalesSummaryReportHeader;
